import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TimestampPipe } from '@scandium-oy/ngx-scandium';
import { AppCommonModule } from 'src/app/common.module';
import { PlaygroundCheckReport } from 'src/app/models/playground-check.model';
import { Site } from 'src/app/models/site.model';
import { playgroundItems } from '../playground';

@Component({
  selector: 'app-print-playground',
  templateUrl: './print-playground.component.html',
  styleUrls: ['./print-playground.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    TimestampPipe,
  ],
})
export class PrintPlaygroundComponent {

  report = input.required<PlaygroundCheckReport>();
  site = input.required<Site>();

  readonly fields = playgroundItems;
}
